<h1 mat-dialog-title class="notification-title">{{ getHeaderText() | async }}</h1>

<mat-dialog-content class="import-result-content">
	<!-- The outcome is announced, so a screen-reader user learns the counts too, not only sighted
	     users. -->
	<div class="import-result-summary" role="status" aria-live="polite">
		@if (isEmpty) {
			<p>{{ 'shared.components.import-error-popup.no-results' | translate }}</p>
		}
		@if (createdCount > 0) {
			<p>
				{{ 'shared.components.import-error-popup.created' | translate: { count: createdCount } }}
			</p>
		}
		@if (updatedCount > 0) {
			<p>
				{{ 'shared.components.import-error-popup.updated' | translate: { count: updatedCount } }}
			</p>
		}
		@if (skippedCount > 0) {
			<p>
				{{ 'shared.components.import-error-popup.skipped' | translate: { count: skippedCount } }}
			</p>
		}
		@if (errorCount > 0) {
			<p>
				<strong>
					{{ 'shared.components.import-error-popup.errors' | translate: { count: errorCount } }}
				</strong>
			</p>
		}
	</div>
	@if (errors.length > 0) {
		<div>
			<h3>{{ 'shared.components.import-error-popup.error-imports' | translate }}</h3>
			<ul class="result-list">
				<!-- Tracked by index: the lists are rendered once and never reordered, and two rows can
				     fail with an identical message, which a message-keyed track would reject. -->
				@for (error of errors; track $index) {
					<li>
						{{ error.message }}
					</li>
				}
			</ul>
		</div>
	}
	@if (skipped.length > 0) {
		<div>
			<h3>{{ 'shared.components.import-error-popup.skipped-imports' | translate }}</h3>
			<ul class="result-list">
				@for (skippedRow of skipped; track $index) {
					<li>{{ skippedRow.message }}</li>
				}
			</ul>
		</div>
	}
	@if (successfulImports.length > 0) {
		<div>
			<h3>{{ 'shared.components.import-error-popup.successful-imports' | translate }}</h3>
			<ul class="result-list">
				@for (import of successfulImports; track $index) {
					<li>{{ import.Id }}</li>
				}
			</ul>
		</div>
	}
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-flat-button mat-dialog-close color="primary">
		{{ 'shared.components.import-error-popup.close' | translate }}
	</button>
</mat-dialog-actions>
